import { cn } from "../../utils/classnames.js";
import { DrawerContent } from "../atoms/drawer.js";
import { ScrollArea } from "./scroll-area.js";
import { jsx } from "react/jsx-runtime";
import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
// src/components/molecules/drawer-panel.tsx
const DrawerPanel = ({ className, scrollFade = true, scrollable = true, allowSelection = true, render, ...props }) => {
	const defaultProps = {
		className: cn(`
        p-6
        in-[[data-slot=drawer-popup]:has([data-slot=drawer-header])]:pt-1
        in-[[data-slot=drawer-popup]:has([data-slot=drawer-footer]:not(.border-t))]:pb-1
      `, { "cursor-default": !allowSelection }, className),
		"data-slot": "drawer-panel"
	};
	const content = useRender({
		defaultTagName: "div",
		props: mergeProps(defaultProps, props),
		render: allowSelection ? /* @__PURE__ */ jsx(DrawerContent, { render }) : render
	});
	if (scrollable) return /* @__PURE__ */ jsx(ScrollArea, {
		className: "touch-auto",
		scrollFade,
		children: content
	});
	else return content;
};
export { DrawerPanel };

//# sourceMappingURL=drawer-panel.js.map